import * as React from 'react';
import './WaitingRoom.css';
import {useTranslation} from "react-i18next";
import {Context} from '../../state/Store';
import { base_url } from '../../config/apiConfig';
import SendMetrics from '../../CourierService/SendMetrics';
import {navTrack} from '../../config/adobeAnalytics';
import SendLogs from '../../CourierService/SendLogs';
import * as _ from 'lodash';
import {signup_environment} from '../../config/apiConfig';

const WaitingRoom = () => {
    const {t} = useTranslation();
    const [state, dispatch] = React.useContext(Context);
    const [counter, setCounter] = React.useState(9);
    const [pollLocationAPI, setPollLocationAPI] = React.useState(false);

    React.useEffect(() => {
        if(state.operationId !== '' && state.paymentStatus === '' && state.consoleUri === '' && pollLocationAPI === true 
            && ((_.isEqual(signup_environment, "miglab") || _.isEqual(signup_environment, "pintlab")) ? ( !_.startsWith(state.accountName, 'actsv2pr') && !_.startsWith(state.accountName,'cc52ef7b06')) : true)) {
            fetch(
                `${base_url}/pollLocationUrl/${encodeURIComponent(state.operationId)}`,
                {
                    method: 'GET',
                    credentials: 'include',
                    headers: {'Content-Type': 'application/json'}
                }
            ).then (async res => {
                if(res.status === 200) {
                    const result = await res.json();
                    let consoleUrl = new URL(result.oneConsoleUri);
                    let params = new URLSearchParams(consoleUrl.search.slice(1));
                    params.append('region', state.homeRegion.value.id);
                    consoleUrl.search = params;
                    SendLogs({severity: '20000', message: 'Account Provisioned: ' + consoleUrl, userSession: state.user_session});
                    dispatch({
                        type: 'UPDATE_URI',
                        payload: consoleUrl
                    });
                }
            }).catch(error => {
                console.log(error);
            })
        }
    }, [counter])

    React.useEffect(() => {
        if(state.operationId !== '' && state.paymentStatus === '' && state.consoleUri === '' && pollLocationAPI === true 
            && ((_.isEqual(signup_environment, "miglab") || _.isEqual(signup_environment, "pintlab")) ? (_.startsWith(state.accountName, 'actsv2pr') || _.startsWith(state.accountName,'cc52ef7b06')) : false)) {
            fetch(
                `${base_url}/accountStatus?workRequestId=${encodeURIComponent(state.operationId)}`,
                {
                    method: 'GET',
                    credentials: 'include',
                    headers: {'Content-Type': 'application/json'}
                }
            ).then (async res => {
                if(res.status === 200) {
                    const result = await res.json();
                    const consoleUri = _.replace(result.oneConsoleUri, '<region>', state.homeRegion.value.id)
                    let consoleUrl = new URL(consoleUri);
                    let params = new URLSearchParams(consoleUrl.search.slice(1));
                    params.append('region', state.homeRegion.value.id);
                    consoleUrl.search = params;
                    SendLogs({severity: '20000', message: 'Account Provisioned: ' + consoleUrl, userSession: state.user_session});
                    dispatch({
                        type: 'UPDATE_URI',
                        payload: consoleUrl
                    });
                }
            }).catch(error => {
                console.log(error);
            })
        }
    }, [counter])

    React.useEffect(() => {
        if(counter === 9) {
            setTimeout(15000);
            setPollLocationAPI(true);
        }
        const timer = state.operationId !== '' && counter > 0 && setInterval(() => setCounter(counter - 1), 10000);
        if(counter === 0) {
            dispatch({
                type:'SHOW_THANK_YOU',
                payload: true
            });
            SendMetrics({name:"PollLocation.Count.Metrics.Failed", value:1, userSession:state.user_session});
            navTrack('oci-signup', state.language, 'provisioning-timeout-90s', 'thankyou-screen-shown');
        }
        return () => clearInterval(timer);
    }, [state.operationId, counter]);

    const renderRedirect = () => {
        if (state.consoleUri !== '') {
          navTrack('oci-signup', state.language, 's2-account-created', 'account-provisioned-by-oci-signup')
          window.location.assign(state.consoleUri);
        }
    }

    return (
        <>
        {state.consoleUri !== '' && renderRedirect()}
        {(state.operationId !== '' && state.paymentStatus === '' && !state.showThankYou) &&
         <div className="waitingRoomContainer">
             <div className="waitingRoomHeader">
                <div className="waitingRoomLoadingGraphic"></div>
                 <div className="waitingRoomMessage">{t('waitingroom.message')}</div>
                 <div className="waitingRoomHelp">
                     {t('waitingroom.needHelp')}
                     <a href="https://oc-cx-en.custhelp.com/app/chat/chat_launch" target='_blank' rel="noopener noreferrer">{t('waitingroom.contactSupport')}</a>
                 </div>
             </div>
             <div className="waitingRoomCarousel">
                <h3 className="title6">{t('waitingroom.slide1Header')}</h3>
                <hr className="" />
                <h2>{t('waitingroom.slide1Title')}</h2>
                <p>{t('waitingroom.slide1Content')}</p>
             </div>
         </div>}
         </>
    )
}

export default WaitingRoom;